module.exports = __webpack_public_path__ + "static/mypage-full-banner-81af1d7873578ba5daf1a694d7255764.jpg";